import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { dashCss } from "./styles";

const style = document.createElement("style");
style.textContent = dashCss;
document.head.append(style);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
